import { createAction } from '@ngrx/store';

export const startAppInitializer = createAction('[Auth] Start initialize app');

export const finishAppInitializer = createAction('[Auth] Finish initialize app');

export const getTokenUserData = createAction('[Auth] Get token user data');
